import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Import standalone components directly in the routes
import { HomePage } from './pages/home/home.page';
import { LoginPage } from './pages/auth/login/login.page';
import { SignUpPage } from './pages/auth/signup/signup.page';
import { ArticlePage } from './pages/article/article.page';
import { SettingsPage } from './pages/settings/settings.page';
import { WelcomePage } from './pages/welcome/welcome.page';
import { StudyPage } from './pages/study/study.page';
import { StudyCardPage } from './pages/study/study-card/study-card.page';
import { UserGuard } from './services/user.guard';
import { TourGuard } from './services/tour.guard';
import { AuthGuard } from './services/auth.guard';
import { SplashPage } from './pages/splash-page/splash-page.page';
import { BeginningPage } from './pages/beginning/beginning.page';
import { LevelPage } from './pages/level/level.page';
import { SetupPage } from './pages/setup/setup.page';
import { AudioSetupPage } from './pages/audio-setup/audio-setup.page';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginPage},
  { path: 'signup', component: SignUpPage },
  { path: 'news', component: HomePage, canActivate: [UserGuard] },
  { path: 'news/:topic', component: HomePage },
  { path: 'article/:id', component: ArticlePage },
  { path: 'settings', component: SettingsPage },
  { path: 'welcome', component: WelcomePage },
  { path: 'study', component: StudyPage },
  { path: 'study/:id', component: StudyCardPage },
  { path: 'splash-page', component: SplashPage },
  { path: 'beginning', component: BeginningPage },
  { path: 'level', component: LevelPage },
  { path: 'setup', component: SetupPage },
  { path: 'audio-setup', component: AudioSetupPage },
  { path: '**', redirectTo: 'news', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }